import * as React from 'react';

import * as Styled from './skeleton-rectangle.styles';
import type { SkeletonRectangleProps } from './skeleton-rectangle.types';

export const SkeletonRectangle = React.forwardRef<
  HTMLDivElement,
  SkeletonRectangleProps
>(
  (
    {
      className,
      cornerRadius,
      height,
      size,
      variant,
      width = '100%',
      ...props
    },
    forwardedRef
  ) => (
    <Styled.SkeletonRectangle
      $cornerRadius={cornerRadius}
      $height={height}
      $size={size}
      $variant={variant}
      $width={width}
      aria-hidden="true"
      className={className}
      data-xds="SkeletonRectangle"
      ref={forwardedRef}
      role="presentation"
      {...props}
    />
  )
);

SkeletonRectangle.displayName = 'SkeletonRectangle';
